import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'

import { BankUsersWithState } from './pages/users-with-state'

export const BankUsers = () => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={<BankUsersWithState />}
    topBarElement={<UserMenuTopBar />}
  />
)
